// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import {
  COLORS,
  BORDER_RADIUS,
  SIZE,
  DEVICE_TYPE,
  MARGIN,
} from "constants/variables";
import { TextPlacement } from "./LegislationSectionModel";

//ASSET
import cursorIcon from "assets/img/Cursor.png";

export const LegislationSectionContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 110px ${SIZE.max200} 0 ${SIZE.max200};
  position: relative;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: 233px ${SIZE.max100} ${SIZE.max100} ${SIZE.max100};
    height: 100%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 150px ${MARGIN.fix24} ${MARGIN.fix32} ${MARGIN.fix24};
    height: 100%;
  }
`;

export const SvgBackground = styled.div`
  position: absolute;
  left: 0;
  bottom: 0%;
  z-index: 0;
  background-repeat: no-repeat;
`;

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 2fr) 1fr 1fr;
  grid-template-rows: repeat(2, auto);
  gap: 24px;
  z-index: 1;
  grid-template-areas:
    "legislation major-events cnsu-decisions authorization-desk"
    "dsu-orders interministerial cnsu-decisions authorization-desk";

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto) auto;
    gap: 12px;
    grid-template-areas:
      "legislation"
      "major-events"
      "interministerial"
      "dsu-orders"
      "bottom-row";
  }
`;

export const Card = styled.div<{
  backgroundColor: string;
  textColor: string;
  gridArea: string;
}>`
  z-index: 2;
  padding: ${SIZE.max40};
  border-radius: ${BORDER_RADIUS.radius24};
  text-align: left;
  position: relative;
  max-height: 224px;
  height: 14.3rem;
  min-height: 164px;
  width: 100%;
  min-width: 150px;
  border: solid 1px ${COLORS.AbsoluteWhite};
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  grid-area: ${({ gridArea }) => gridArea};
  opacity: 0.96;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  &:hover {
    opacity: 1;
  }
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  ${({ gridArea }) =>
    gridArea === "cnsu-decisions" || gridArea === "authorization-desk"
      ? css`
          max-height: 472px;
          height: 100%;
          min-height: 342px;
        `
      : null}
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    max-height: 164px;
  }

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    ${({ gridArea }) =>
      gridArea === "cnsu-decisions" || gridArea === "authorization-desk"
        ? css`
            grid-area: bottom-row;
            max-height: 342px;
          `
        : null}
    ${({ gridArea }) =>
      gridArea === "cnsu-decisions"
        ? css`
            width: calc(50% - 6px);
            grid-area: bottom-row;
            max-height: 342px;
          `
        : null}
         ${({ gridArea }) =>
      gridArea === "authorization-desk"
        ? css`
            justify-self: end;
            width: calc(50% - 6px);
          `
        : null}
  }
`;

export const TextWrapper = styled.div<{ placement: TextPlacement }>`
  z-index: 10 !important;
  position: relative;
  display: flex;
  ${({ placement }) =>
    placement === TextPlacement.right
      ? css`
          justify-content: flex-end;
          text-align: right;
          flex-direction: column;
        `
      : css`
          justify-content: flex-start;
          text-align: left;
          flex-direction: column;
        `}
  padding: ${SIZE.max10};
`;

export const SVGWrapper = styled.div<{
  position: { bottom?: string; left?: string; right?: string; top?: string };
  transform?: string;
  opacity?: number;
}>`
  position: absolute;
  z-index: 5 !important;

  bottom: ${({ position }) => position.bottom || "auto"};
  left: ${({ position }) => position.left || "auto"};
  right: ${({ position }) => position.right || "auto"};
  top: ${({ position }) => position.top || "auto"};
  transform: ${({ transform }) => transform || "none"};
  opacity: ${({ opacity }) => opacity || 1};

  svg {
    height: auto;
    width: auto;

    ${({ height }) =>
      height === "legislation" &&
      css`
        height: 179px;
        @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
          height: 130px;
        }
      `}

    ${({ height }) =>
      height === "major-events" &&
      css`
        height: 141px;
        @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
          height: 117px;
        }
      `}
      ${({ height }) =>
      height === "dsu-orders" &&
      css`
        height: 189px;
        @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
          height: 117px;
        }
      `}
      ${({ height }) =>
      height === "interministerial" &&
      css`
        height: 141px;
        @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
          height: 117px;
        }
      `}
      ${({ height }) =>
      height === "cnsu-decisions" &&
      css`
        height: 141px;
        @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
          height: 117px;
        }
      `}
      ${({ height }) =>
      height === "authorization-desk" &&
      css`
        height: 220px;
        @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
          height: 157px;
        }
      `}
  }
`;
